module.exports = __webpack_public_path__ + "img/smartknife2.e22e6b2e.png";